import { Controller } from "@hotwired/stimulus"

const RESUME_EVENTS = ["scroll", "wheel", "touchmove", "keydown"]
const SCROLL_KEYS = ["ArrowDown", "End", "PageDown", " "]
const SCROLL_SETTLE_TIME = 100

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.loading = false
    this.recordLoad = this.recordLoad.bind(this)
    this.resumeAfterRestoration = this.resumeAfterRestoration.bind(this)
    this.resumeFromUserScroll = this.resumeFromUserScroll.bind(this)
    this.startObserving = this.startObserving.bind(this)

    if (!this.hasLinkTarget) return

    this.linkTarget.addEventListener("click", this.recordLoad)

    if (this.restorationInProgress()) {
      document.addEventListener("booking-restoration:finished", this.resumeAfterRestoration, { once: true })
    } else {
      this.startObserving()
    }
  }

  disconnect() {
    this.observer?.disconnect()
    this.linkTarget?.removeEventListener("click", this.recordLoad)
    document.removeEventListener("booking-restoration:finished", this.resumeAfterRestoration)
    this.stopWaitingForUser()
  }

  startObserving() {
    this.stopWaitingForUser()
    if (!this.hasLinkTarget || this.observer) return

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.load()
        }
      },
      { rootMargin: "240px 0px" }
    )

    this.observer.observe(this.element)
  }

  resumeAfterRestoration() {
    this.scrollResumeAt = performance.now() + SCROLL_SETTLE_TIME
    RESUME_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, this.resumeFromUserScroll, { passive: true })
    })
  }

  resumeFromUserScroll(event) {
    if (event.type === "scroll" && performance.now() < this.scrollResumeAt) return
    if (event.type === "keydown" && !SCROLL_KEYS.includes(event.key)) return

    this.startObserving()
  }

  stopWaitingForUser() {
    RESUME_EVENTS.forEach((eventName) => window.removeEventListener(eventName, this.resumeFromUserScroll))
  }

  load() {
    if (this.loading || !this.hasLinkTarget || this.restorationInProgress()) return

    this.loading = true
    this.linkTarget.click()
  }

  recordLoad(event) {
    if (this.restorationInProgress()) {
      event.preventDefault()
      return
    }

    this.dispatch("load", { detail: { url: this.linkTarget.href } })
  }

  restorationInProgress() {
    return Boolean(this.element.closest('[data-booking-restoration-replaying="true"]'))
  }
}
